/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { cn, getPath } from '@express-labs/raven-tools';
import MegaMenu from '../../../components/MegaMenu';
import s from './DesktopNavigation.module.scss';

export default function DesktopNavigation({
  displayRewardsToolTip = false,
  hideTopHeader = false,
  loginStatus,
  navData = {},
  stickyHeaderLimited,
  topPosition = 0,
  width = 0,
}) {
  return (
    <MegaMenu
      className={cn(s.desktop, 'ravenDesktopNav')}
      menuList={getPath(navData, 'menuNavigation', [])}
      menuLabel="Express Departments"
      hideTopHeader={hideTopHeader}
      stickyHeaderLimited={stickyHeaderLimited}
      width={width}
      displayRewardsToolTip={displayRewardsToolTip}
      loginStatus={loginStatus}
      topPosition={topPosition}
    />
  );
}

DesktopNavigation.propTypes = {
  displayRewardsToolTip: PropTypes.bool,
  hideTopHeader: PropTypes.bool.isRequired,
  loginStatus: PropTypes.bool,
  navData: PropTypes.shape({}),
  stickyHeaderLimited: PropTypes.bool.isRequired,
  topPosition: PropTypes.number,
  width: PropTypes.number,
};


